import Pills from "modules/Common/Components/Pills";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { Space } from "antd";

interface ITab {
  pillName?: string;
  to?: any;
  isActive: boolean;
  isDisabled?: boolean;
  onClick?: any;
}
interface ITabOptionsProps {
  tabArray: Array<ITab>;
}

const AnalyticsTabOption = ({ tabArray }: ITabOptionsProps) => {
  // console.log(tabArray);
  return (
    <TabContainer>
      <ul>
        <Space>
          {tabArray.map((pill, index) => {
            if (pill.pillName === "Trends")
              return (
                <li key={index}>
                  <a className={`${pill.isDisabled ? "disabled" : ""}`}>
                    <Pills title={pill.pillName} active={pill.isActive} onClick={pill.onClick} />
                  </a>
                </li>
              );
            return (
              <li key={index}>
                <Link to={pill.to} className={`${pill.isDisabled ? "disabled" : ""}`}>
                  <Pills title={pill.pillName} active={pill.isActive} onClick={pill.onClick} />
                </Link>
              </li>
            );
          })}
        </Space>
      </ul>
    </TabContainer>
  );
};

const TabContainer = styled.div`
  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
  }
  .disabled {
    pointer-events: none;
    opacity: 0.6;
  }
`;
export default AnalyticsTabOption;
